import { useQuery } from 'react-query';

import { getReportsFilters } from 'utils/api/baas/reportsFiltersV2';

const useGetCatalogReportFilters = ({ enabled = false }: { enabled: boolean }) => {
  return useQuery('report-filters', getReportsFilters, { enabled });
};

export default useGetCatalogReportFilters;
